import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungMinden() {
  return (
    <CityPageTemplate
      city="Minden"
      slug="minden"
      intro="Minden als Stadt an der Porta Westfalica – Deine Finanzen sollten genauso stark und beständig sein."
      description="Unabhängige & digitale Finanzberatung für Minden: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
